import * as React from "react";
import { Alert, AlertDescription } from "@zapier/design-system";

import styles from "./BlockedLinkAlert.module.css";

interface BlockedLinkAlertProps {
  onDismiss: () => void;
}

export const BlockedLinkAlert: React.FC<BlockedLinkAlertProps> = ({
  onDismiss,
}) => {
  return (
    <div className={styles.alertWrapper}>
      <Alert
        status="warning"
        onDismiss={(e) => {
          // prevents node being selected and sidebar opening
          e.stopPropagation();
          onDismiss();
        }}
        title="This link has been blocked."
      >
        <AlertDescription>
          Zapier blocks access to some external sites that may be unsafe or
          violate company policies.
        </AlertDescription>
      </Alert>
    </div>
  );
};
